import React from "react";
import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "../lib/site";

export const EditorialMarquee = () => (
  <div data-testid="marquee" className="py-8 border-y border-white/[0.06] bg-surface/40 overflow-hidden">
    <Marquee speed={38} gradient={false} autoFill>
      {MARQUEE_WORDS.map((w, i) => (
        <span key={`${w}-${i}`} className="flex items-center">
          <span className="font-serif text-4xl md:text-6xl font-light tracking-tight text-white/90 mx-8">
            {w}
          </span>
          <span className="text-gold text-3xl md:text-5xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
